var utils = require('lib/utils');

(function (EF) {
  var ResponseSet = Backbone.Model.extend({

    url: function () {
      return `${this.get('endpoint')}/response_sets/${this.get('id')}.json?include=${this.includes}`;
    },

    includes: '',

    fileName: function() {
      return `response-sets/${this.get('id')}.json`;
    },

    responseForQuestionBySlug: function (slug) {
      let question;

      this.get('sections').forEach(function(section) {
        if(!question) {
          question = _.find(section.questions, function(question) {
            return question.slug === slug;
          });
        }
      });

      if(question) {
        return this.getSelectedAnswers(question);
      } else {
        return null;
      }
    },

    getSelectedAnswers: function (question) {
      const answersSelected = _.find(this.get('responseSet').answers, function (currentResponse) {
        return currentResponse.question_id == question.id;
      });
      if (answersSelected) {
        if (answersSelected.value && answersSelected.value.length > 1) {
          var answerList = [];
          answersSelected.value.forEach(selectedAnswer => {
            const answerInfo = this._getInformationFromSelectedAnswers(question, selectedAnswer);
            answerList.push(answerInfo);
          });
          return this._createQuestionAndAnswersData(question, answerList);
        } else {
          const singleAnswer = this._getInformationFromSelectedAnswers(question, answersSelected.value);
          return this._createQuestionAndAnswersData(question, singleAnswer);
        }
      }
    },

    _getInformationFromSelectedAnswers: function (question, selectedAnswer) {
      const answers = _.find(question.answers, function (answer) {
        return selectedAnswer == answer.id;
      });
      return answers;
    },

    _createQuestionAndAnswersData: function (question, answers) {
      return _.extend({}, {
        answers: answers,
        question: question
      });
    },

    parse: function (response) {
      if(!response) {
        return {};
      }
      this.set('responseSet', response.data && response.data.attributes ? response.data.attributes : {});
      let responseData = null;
      if (response.data) {
        responseData = utils.sanifyJsonApiObject(response.data, response.included);
        responseData.sections = _.orderBy(responseData.sections, 'position');
        responseData.sections.forEach((section) => {
          section.questions = _.orderBy(section.questions, 'position');
          section.questions.forEach((question) => {
            question.answers = _.orderBy(question.answers, 'position');
          });
        });
      }
      return responseData;
    },

    save: function (selectedAnswers, options) {
      options = options || {};
      options.headers = { 'Authorization': `Bearer ${this.get('token')}` };
      let answers = selectedAnswers.map((answer) => {
        return {
          question_id: answer.question_id,
          value: answer.answers ? answer.answers : answer.answer_id,
          response_type: answer.answers ? 'multiple_selection' : 'single_selection'
        };
      });
      options.attrs = {
        data: {
          id: this.get('id'),
          type: 'response_sets',
          attributes: {
            answers: answers
          }
        }
      };
      return options;
    }
  });

  _.extend(EF.Models.Evaluations, {
    ResponseSet: ResponseSet
  });

}(EF));
